import Entity from '../entity'

export default class Coupon extends Entity<number>{
    couponNo: string  = null;
    couponTypeId: number  = null;
    couponTypeNo: string  = null;
    tenantId: number  = null;
    isGot: boolean;
    remark: string  = null;
}